import produce from "immer";
import { reviewActions } from ".";

import { IStoreState } from "../initialStoreState";
import { defaultGoogleReviewState } from "./review.state";

import { LoadState } from "../../constants/enums";
import {
	FETCH_GOOGLE_REVIEW_LIST_FAILED,
	FETCH_GOOGLE_REVIEW_LIST_PROGRESS,
	FETCH_GOOGLE_REVIEW_LIST_SUCCESS,
} from "./reviewAction";

export const googleReviewReducer = (
	state: IStoreState["review"] = defaultGoogleReviewState,
	action: reviewActions
) => {
	switch (action.type) {
		case FETCH_GOOGLE_REVIEW_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.NotLoaded;
				draftState.list.data = [];
				draftState.list.totalRecords = 0;
			});
			return newState;
		}
		case FETCH_GOOGLE_REVIEW_LIST_SUCCESS: {
			const { data } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.data = data;
				draftState.list.error = null;
			});
			return newState;
		}

		case FETCH_GOOGLE_REVIEW_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
			});
			return newState;
		}
		default: {
			return state;
		}
	}
};
